import { render, staticRenderFns } from "./AddDiscountProductModal.vue?vue&type=template&id=38e6a2ca&scoped=true"
import script from "./AddDiscountProductModal.vue?vue&type=script&lang=js"
export * from "./AddDiscountProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e6a2ca",
  null
  
)

export default component.exports